// core version + navigation, pagination modules:
import Swiper from "swiper";
import { Navigation, Pagination, A11y } from "swiper/modules";



const componentSlider = () => {
var swiper = new Swiper(".swiper", {
  modules: [Navigation, Pagination, A11y],
  slidesPerView: 1,
  spaceBetween: 30,
  loop: true,
  threshold: 10,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  a11y: {
    enabled: true,
    prevSlideMessage: 'Zurück zur vorherigen Galerie-Seite',
    nextSlideMessage: 'Weiter zur nächsten Galerie-Seite',
    paginationBulletMessage: 'Gehe zu Galerie-Seite {{index}}',
  }
});

    }

export default componentSlider;